import { axiosIns } from "../utils";

export const fetchQuestions = async (params = {}) => {
  const res = await axiosIns.get("/questions/", { params });
  return res && res.data ? res.data : res;
};

export const fetchQuestion = async (id) => {
  const res = await axiosIns.get(`/questions/${id}/`);
  return res && res.data ? res.data : res;
};

export const respondToQuestionApi = async (id, payload) => {
  const res = await axiosIns.post(
    `/questions/${id}/respond_question/`,
    payload
  );
  return res && res.data ? res.data : res;
};

export const takeQuestionApi = async (id, payload) => {
  const res = await axiosIns.patch(`/questions/${id}/take_question/`, payload);
  return res && res.data ? res.data : res;
};

export const hideQuestionApi = async (id) => {
  const res = await axiosIns.patch(`/questions/${id}/hide/`);
  return res && res.data ? res.data : res;
};

export const unhideQuestionApi = async (id) => {
  const res = await axiosIns.patch(`/questions/${id}/unhide/`);
  return res && res.data ? res.data : res;
};

export const hideResponseApi = async (id) => {
  const res = await axiosIns.patch(`/response/${id}/hide/`);
  return res && res.data ? res.data : res;
};

export const unhideResponseApi = async (id) => {
  const res = await axiosIns.patch(`/response/${id}/unhide/`);
  return res && res.data ? res.data : res;
};
